<template>
    <div class="experience-application-body">
        <img 
            :src="n" 
            class="experience-application-bg-icon"
            v-for="(n, index) in bgIconList"
            :key="index"
        />
        <div class="experience-application-inset">
            <div class="logo-area">
                <img :src="logo" />
            </div>
            <div class="experience-application-title">
                1週間<img :src="experienceApplicationImport"/>体験
            </div>
            <div class="experience-application-min-title">
                海外で日本のテレビを観るアプリ！
            </div>
            <div class="experience-application-btn">
                <img :src="btn" @click="routerTo('/sendMessage')"/>
            </div>
        </div>
    </div>
</template>
<script>
import { logo, experienceApplicationImport, btn, bgIconList } from '../../../images/experience-application'
export default {
    data () {
        return {
            logo,
            experienceApplicationImport,
            btn,
            bgIconList
        }
    },
    methods: {
        routerTo (path) {
            this.$router.push(path)
        }
    }
}
</script>
<style scoped>
.experience-application-body {
    position: relative;
    padding: 30px 40px;
    box-sizing: border-box;
    width: 100%;
    background: #FDB819;
    overflow: hidden;
}
.experience-application-inset {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    text-align: center;
}
.logo-area img {
    display: block;
    height: 22.5px;
}
.experience-application-title {
    font-size: 30px;
    font-family: A-OTF Gothic MB101 Pr5;
    font-weight: bold;
    line-height: 60px;
    color: #000000;
}
.experience-application-title img {
    display: inline-block;
    height: 75px;
    vertical-align: bottom;
}
.experience-application-min-title {
    margin-top: 10px;
    font-size: 15px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
    margin-bottom: 20px;
}
.experience-application-btn img {
    display: block;
    height: 25px;
}
.experience-application-btn {
    margin: 0 auto;
    background: #FDB819;
    padding: 10px 20px;
    display: inline-block;
    border-radius: 100px;
}
.experience-application-body .experience-application-bg-icon {
    position: absolute;
    display: block;
}

.experience-application-body .experience-application-bg-icon:nth-child(1) {
    height: 133px;
    left: -5px;
    top: 124px;
}
.experience-application-body .experience-application-bg-icon:nth-child(2) {
    height: 70px;
    right: -5px;
    bottom: 33px;
}
.experience-application-body .experience-application-bg-icon:nth-child(3) {
    height: 48px;
    top: 50px;
    right: -20px;
}
</style>